<div class="flex items-center justify-center dialog-header ">
  {{formAction}} Pakcage

  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>

</div>


<div class="dialog-content">
  <div class="p-4">
    <form [formGroup]="packageForm" (ngSubmit)="submitForm()" class="space-y-4">

      <div>
        <label class="block font-medium mb-1">Package Name *</label>
        <input pInputText formControlName="package_name" class="w-full" />
      </div>

      <!-- Features -->
      <div>
        <label class="block font-medium mb-1">Features *</label>
          <p-multiselect [options]="featureListOptions" formControlName="features" appendTo="body" optionLabel="name"
            placeholder="Select Features" styleClass="w-full md:w-80" />
      </div>

      <div>
        <label class="block font-medium mb-1">Type *</label>
        <!-- <input pInputText formControlName="type" class="w-full" /> -->
        <p-select appendTo="body" [options]="['Basic', 'Premium']"  formControlName="type"
        placeholder="Select Type" class="w-full"></p-select>
      </div>

      <div>
        <label class="block font-medium mb-1">Validity (Days) *</label>
        <input pInputText type="number" formControlName="validity" class="w-full" />
      </div>

      <div>
        <label class="block font-medium mb-1">Status *</label>
        <p-select appendTo="body" [options]="['Active', 'Inactive']" formControlName="status"
          placeholder="Select status" class="w-full"></p-select>
      </div>

      <div class="flex items-center space-x-2">
        <label class="block font-medium">Customized</label>
        <p-toggleswitch formControlName="is_customized" />
      </div>


       <div class="flex items-center space-x-2 mt-4">
        <input pInputText formControlName="featureName" placeholder="Add new feature" class="flex-1" />
        <button type="button" 
        pButton label="Add Feature" icon="pi pi-plus" (click)="addFeature()" class="p-button-sm"></button>
      </div>


      <div class="pt-4">
        <button type="submit" pButton label="Submit" icon="pi pi-check" [loading]="isLoading"
          [disabled]="packageForm.invalid || isLoading" class="w-full"></button>
      </div>
    </form>
  </div>
</div>